// extracted by mini-css-extract-plugin
module.exports = {"body":"_dea1acf","darkMode":"_5e5b396"};